module.exports = __webpack_public_path__ + "img/homepage_3--mobile@3x.ebadf401.jpg";